import { useState } from 'react';
import { FiltersType, FilterType } from '../types/types';
import Filter from './Filter';

const Filters = ({ categories, categoryChange }: FiltersType) => {
	const [activeCategory, setActiveCategory] = useState<string | null>(null);

	const handleClick = (category: string | null) => {
		categoryChange(category);
		setActiveCategory(category);
	};

	if (!categories) {
		return (
			<div className="dynamic-news__filters">
				<span>No categories found</span>
			</div>
		);
	}

	return (
		<div className="dynamic-news__filters">
			<span className="dynamic-news__filter" onClick={() => handleClick(null)}>
				Alle
			</span>
			{categories.map((category: FilterType) => {
				return <Filter key={category.id} category={category} handleClick={handleClick} activeCategory={activeCategory} />;
			})}
		</div>
	);
};

export default Filters;
